import { Dialog } from "primereact/dialog"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVRadioBtn } from "../../../shared/JVRadioBtn";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { ICompletedTrainigs } from "./Table";
import { IQuestion } from "../trainingMasters/trainingQuestions/Table";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";

interface IProps {
    open: boolean,
    singleData: ICompletedTrainigs,
    bodyData: {
        Rating?: number,
        Feedback?: string,
        Schedule_ID?: number,
    },
    hideDialog: () => void,
    reloadTable: () => void,
    removeStars: () => void,
    toast: any,
}

interface IQuestionAns {
    question_ID?: number,
    question?: string,
    rating?: number | null,
    feedback?: string | null,
}

const schema = yup.object({
    training_Status: yup.string().nullable(),
    training_Status_Reason: yup.string().nullable(),
});

export const TrainingRatingAnswers = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [disableAll, setDisableAll] = useState<boolean>(false);
    const [changes, setChanges] = useState<boolean>(false);
    const [questionAns, setQuestionAns] = useState<Array<IQuestionAns>>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: { training_Status: "" },
        shouldFocusError: false
    });

    const loadQuestions = async () => {
        const response = await Fetch("CarnivalTraining/getActiveQuestionsForRating", "GET", null, `topic_ID=${props.singleData.topic_ID}`, props.toast);

        if (response) {
            const data: IQuestion[] = await response.json();

            if (data.length === 0) {
                onSubmit(true);
            }

            setQuestionAns(data.map((ele: any) => {
                return {
                    question_ID: ele.question_ID,
                    question: ele.question,
                    rating: null,
                    feedback: null,
                };
            }));
        }
    }

    const loadQuestions2 = async () => {
        const response = await Fetch("CarnivalTraining/getActiveQuestions", "GET", null, `topic_ID=${props.singleData.topic_ID}`, props.toast);

        if (response) {
            const data: IQuestion[] = await response.json();
            setQuestionAns(data.map((ele: any) => {
                return {
                    question_ID: ele.question_ID,
                    question: ele.question,
                    rating: (props.singleData.answers || []).filter((el: any) => el.question_ID === ele.question_ID)[0].rating,
                    feedback: (props.singleData.answers || []).filter((el: any) => el.question_ID === ele.question_ID)[0].feedback,
                };
            }));
        }
    }

    const onSubmit = async (ignore?: boolean) => {
        const checkNotAnswered = questionAns.filter(el => (el.rating === null || el.rating === 0));
        const checkNotCommented = questionAns.filter(el => (el.rating === 1 || el.rating === 5) && (el.feedback === null || el.feedback?.trim() === ""));
        if (checkNotAnswered.length > 0 && ignore != true) {
            props.toast.current.show({ severity: 'error', detail: "Please Rate all questions", life: 3000 });
        } else if (checkNotCommented.length > 0 && ignore != true) {
            props.toast.current.show({ severity: 'error', detail: "Please Give Feedback For 1 Star and 5 Star ratings", life: 3000 });
        } else {
            setLoading(true);
            const newBodyData = {
                Body: props.bodyData,
                Answers: questionAns.map((ele: any) => {
                    return {
                        Question_ID: ele.question_ID,
                        rating: ele.rating,
                        feedback: ele.feedback,
                    };
                })
            }
            const response = await Fetch("CarnivalTraining/addRating", "POST", newBodyData, null, props.toast);
            if (response) {
                setLoading(false);
                props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
                onHide();
            } else setLoading(false);
        }

    }

    const onHide = () => {
        setLoading(false);
        setDisableAll(false);
        props.reloadTable();
        props.hideDialog();
    }

    useEffect(() => {
        if (props.open && props.singleData?.answers && props.singleData?.answers?.length > 0) {
            setDisableAll(true);
            loadQuestions2();
        } else if (props.open) {
            loadQuestions();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header={disableAll ? "Answers" : "Answer All Questions"} modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid flex flex-column">
                {questionAns.map((ele: IQuestionAns, index: number) => <div className="flex flex-column" style={{ border: "1px solid black", marginTop: "10px" }}>
                    <div key={index} className="field col-12 md:col-12 flex align-items-center ml-2"><p style={{ paddingTop: "5px", width: "70%" }}>Q{index + 1}. {ele.question}</p>
                        <div className="flex gap-3 mt-1">
                            {/* <div>
                            <RadioButton disabled={disableAll} inputId={`${index}`} value={true} onChange={(e: any) => {
                                let data = questionAns;
                                data[index].answer = e.value;
                                setQuestionAns([...data]);
                                setChanges(!changes);
                            }} checked={ele.answer === true} />
                            <label htmlFor="" className="ml-2">Yes</label>
                        </div>
                        <div>
                            <RadioButton disabled={disableAll} inputId={`${index}`} value={false} onChange={(e: any) => {
                                let data = questionAns;
                                data[index].answer = e.value;
                                setQuestionAns([...data]);
                                setChanges(!changes);
                            }} checked={ele.answer === false} />
                            <label htmlFor="" className="ml-2">No</label>
                        </div> */}
                            <StarsLine singleData={props.singleData} rating={(ele.rating || 0)} feedback={(ele.feedback || "")} index={index} questionAns={questionAns} setQuestionAns={(data: IQuestionAns[]) => setQuestionAns(data)} setChanges={() => setChanges(!changes)} />
                        </div>
                    </div>
                    {props.singleData.rating_ID !== null && ele.feedback !== null && ele.feedback?.trim() !== "" && <div className="flex gap-3" style={{ marginTop: "-25px", marginLeft: "25px", fontWeight: "bold", marginBottom: "10px" }}><span>Feedback : </span><p style={{ color: "grey" }}>{ele.feedback}</p></div>}
                </div>)}
                {!disableAll && <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SUBMIT" type="submit" loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={() => {
                        onHide();
                        if (props.singleData.rating === null) props.removeStars();
                    }} type="button" className="p-button-outlined surface-200"></Button>
                </div>}
            </form>
        </Dialog>
    );
}

interface IStarsProps {
    singleData: ICompletedTrainigs,
    rating: number,
    feedback: string,
    index: number,
    questionAns: IQuestionAns[],
    setQuestionAns: (data: IQuestionAns[]) => void,
    setChanges: () => void,
}
const StarsLine = (props: IStarsProps) => {
    const [hover, setHover] = useState<number>(0);

    return <div className="flex flex-column">
        <div key={props.index} style={styles.stars}>
            {
                [1, 2, 3, 4, 5].map((star: number, idx: number) => (
                    <span
                        key={idx}
                        onMouseEnter={() => {
                            if (props.singleData.rating_ID === null || props.singleData.rating_ID === 0) setHover(star);
                        }}
                        onMouseLeave={() => {
                            if (props.singleData.rating_ID === null || props.singleData.rating_ID === 0) setHover(0);
                        }}
                        onClick={() => {
                            if (props.singleData.rating_ID === null || props.singleData.rating_ID === 0) {
                                let data = props.questionAns;
                                data[props.index].rating = star;
                                props.setQuestionAns([...data]);
                                props.setChanges();
                            }
                        }}
                        style={{
                            ...styles.star,
                            color: star <= (hover || (props.rating || 0)) ? "#FFD700" : "#ccc",
                        }}
                    >
                        ★
                    </span>
                ))
            }
        </div>
        {(props.singleData.rating_ID === null) && (props.rating === 1 || props.rating === 5) && <textarea
            placeholder="Write your feedback about the trainer..."
            value={props.feedback}
            onChange={(e) => {
                let data = props.questionAns;
                data[props.index].feedback = e.target.value;
                props.setQuestionAns([...data]);
                props.setChanges();
            }}
            style={styles.textarea}
            disabled={props.singleData.rating_ID !== null && props.singleData.rating_ID !== undefined && props.singleData.rating_ID !== 0}
        />}
    </div>;
}

const styles: Record<string, React.CSSProperties> = {
    stars: {
        fontSize: "32px",
        marginBottom: "16px",
        display: "flex",
        gap: "8px",
        cursor: "pointer",
    },
    star: {
        cursor: "pointer",
        transition: "0.2s",
        height: "3rem"
    },
};